import { render, staticRenderFns } from "./file.vue?vue&type=template&id=5f6c27d5&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=5f6c27d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c27d5",
  null
  
)

export default component.exports